import React from 'react'
import Button from '@mui/material/Button'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  fontSize: '16px',
  width: '100%',
  height: '100%',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: theme.palette.secondary.dark,
  },
}))

// Confirm Reset Password Success - This is a Centered Button
export function ConfirmButton({ onClick, text }) {
  return (
    <StyledButton onClick={onClick} variant='contained'>
      {text}
    </StyledButton>
  )
}

ConfirmButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}
